<template>
  <div class="preview-image" v-if="swiperData.length">
    <div class="top-bar">
      <div class="top-flex">
        <i class="iconfont icon-fanhui" v-if="!isWx" @click="goback"></i>
        <p class="title">{{ swiperData[curSwiper].title }}</p>
      </div>
      <!-- <div class="desc">#普通结营感言</div> -->
    </div>
    <div
      class="image-content"
      :class="{ 'image-content-open': infoOpen }"
      ref="imageBox"
      @touchstart="bindtouchstart"
      @touchend="bindtouchend"
      @touchmove="bindtouchmove"
    >
      <div
        class="image-box"
        :style="{ height: imageHeight + 'px' }"
        :class="{ 'image-close': infoOpen }"
        ref="image"
      >
        <van-image
          v-for="(item, index) in swiperData"
          :key="index"
          @click="bindClickSwiper"
          v-show="!editIconList[0].active"
          class="van-image item-image"
          fit="contain"
          :src="item.info"
        />
        <div class="poster-content" v-show="editIconList[0].active">
          <div style="opacity: 0">
            <div ref="poster" class="poster-box">
              <van-image
                class="van-image poster-image"
                fit="contain"
                :src="swiperData[curSwiper].info"
              />
              <div class="poster-text">
                <p>世界的善意</p>
                <p>是温柔的你和夏天的风</p>
              </div>
              <p class="poster-info">
                <span class="class-name">{{ swiperData[curSwiper].alias }}</span
                ><span>{{ swiperData[curSwiper].camp_coach || '' }}</span>
              </p>
              <img class="poster-seal" :src="sealUrl" />
            </div>
          </div>
          <!-- 美化后的图片 -->
          <div class="beautiful-image-box">
            <van-image
              v-if="beautifyImageSource"
              class="van-image beautiful-image"
              fit="contain"
              :src="beautifyImageSource"
            />
          </div>
        </div>
        <!-- <img class="van-image" v-show="editIconList[0].active" @load="loadBeatifulImage" :src="beautifyImageSource" alt="" crossorigin="anonymous"> -->
      </div>
      <div class="image-info">
        <div class="info-content">
          <div class="desc-content" v-if="swiperData[curSwiper].disc">
            <p class="info-desc" :class="{ 'desc-limit': !showMore }">{{
              swiperData[curSwiper].disc || ''
            }}</p>
            <span class="more" @click="bindShowMore" v-show="!showMore"
              >更多</span
            >
          </div>
          <p class="info-text" v-if="swiperData[curSwiper].addtime"
            ><span class="iconfont icon-clock-4"></span
            ><span class="info-left">时间</span
            ><span class="info-right">{{
              swiperData[curSwiper].addtime || ''
            }}</span></p
          >
          <p class="info-text" v-if="swiperData[curSwiper].alias"
            ><span class="iconfont icon-warehouse-2"></span
            ><span class="info-left">班级</span
            ><span class="info-right">{{
              swiperData[curSwiper].alias || ''
            }}</span></p
          >
          <p class="info-text" v-if="swiperData[curSwiper].opt_name"
            ><span class="iconfont icon-warehouse-2"></span
            ><span class="info-left">上传人</span
            ><span class="info-right">{{
              swiperData[curSwiper].opt_name || ''
            }}</span></p
          >
          <p class="info-text" v-if="swiperData[curSwiper].author_name"
            ><span class="iconfont icon-zhongjianren"></span
            ><span class="info-left">作者</span
            ><span class="info-right">{{
              swiperData[curSwiper].author_name || ''
            }}</span></p
          >
          <p class="info-text" v-if="swiperData[curSwiper].truename"
            ><span class="iconfont icon-zhongjianren"></span
            ><span class="info-left">学员</span
            ><span class="info-right">{{
              swiperData[curSwiper].truename || ''
            }}</span></p
          >
        </div>
      </div>
    </div>
    <div class="edit-content">
      <div
        class="edit-item"
        :class="{ active: item.active }"
        v-for="(item, index) in editIconList"
        :key="index"
        @click="handleChange(index)"
      >
        <i
          class="iconfont active"
          v-if="item.active"
          :class="[item.activeIconfont]"
        ></i>
        <i class="iconfont" v-else :class="[item.iconfont]"></i>
        <p class="edit-name">{{ item.name }}</p>
      </div>
    </div>
    <!-- 收藏提示 -->
    <van-dialog
      v-model="showCollect"
      title="收藏成功"
      :show-confirm-button="false"
      :show-cancel-button="true"
      cancel-button-text="关闭"
    >
      <p class="notice">
        可前往 <span style="color: #2882e9">首页-我的收藏</span> 查看
      </p>
    </van-dialog>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
import html2canvas from 'html2canvas'
const wx = require('weixin-js-sdk')
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    index1: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showPreview: true,
      infoOpen: false, //信息描述是否展开
      previewImages: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg'
      ],
      swiperData: [], //轮播图数据
      showCollect: false,
      isWx: false,
      nickname: '',
      sealUrl:
        'https://cdnvue.gymcity.com.cn/uploads/981e6119a90b19cdc77177de9e80f6c9.png', //印章图片
      imageUrl:
        'https://cdnvue.gymcity.com.cn/uploads/610c31c1b6145a566cb313048a26edf1.png', //当前展示的图片地址
      beautifyImageUrl: '', //美化后的图片
      beautifyImageSource: null, //美化后的图片
      editIconList: [
        {
          active: false,
          iconfont: 'icon-shuaxin1',
          activeIconfont: 'icon-shuaxin1',
          name: '一键美化',
          runFunc: 'clickBeautification'
        },
        {
          active: false,
          disabledActive: true,
          iconfont: 'icon-zhuanfa',
          activeIconfont: 'icon-zhuanfa',
          name: '发布',
          miniPath: '/pages/publish/publish' //小程序路径
        },
        {
          active: false,
          iconfont: 'icon-shoucang',
          activeIconfont: 'icon-shoucang1',
          name: '收藏',
          runFunc: 'collect'
        }
      ],
      curSwiperIndex: 0,
      curSwiperIndex1: 0,
      curSwiper: 0,
      totalSwiper: 0,
      lastSwiper: 0,
      imageHeight: '100%', //图片实时高度
      originImageHeight: 0,
      showMore: false
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper.swiper
    }
  },
  watch: {
    data() {
      this.updateCllect()
    }
  },
  created() {
    this.swiperData = [this.data]
    this.updateCllect(true)
    this.getEv()
  },
  mounted() {},
  methods: {
    bindShowMore() {
      this.showMore = true
    },
    bindtouchstart(e) {
      if (e.touches.length == 1) {
        let touch = e.touches[0]
        this.startY = touch.pageY
        this.preY = touch.pageY
        this.imageHeight = this.$refs.image.clientHeight
      }
    },
    bindtouchend(e) {
      if (e.changedTouches.length == 1) {
        let touch = e.changedTouches[0]
        let endY = touch.pageY
        let move = endY - this.startY
        if (move > 0 && this.isScrollTop()) {
          //向下
          this.infoOpen = false
          this.imageHeight = this.$refs.imageBox.clientHeight
        } else if (move < 0) {
          //向上
          this.infoOpen = true
          this.imageHeight = 0.4 * this.$refs.imageBox.clientHeight
        }
      }
    },
    bindtouchmove(e) {
      if (e.changedTouches.length == 1) {
        let touch = e.changedTouches[0]
        let curY = touch.pageY
        let move = curY - this.preY
        this.preY = curY
        if (move > 0 && this.isScrollTop()) {
          //向下
          return
        } else if (move < 0 && this.isScrollBottom()) {
          //向上
          return
        }
        this.imageHeight = this.imageHeight + move / 2
      }
    },
    //是否滚动到底部了
    isScrollBottom() {
      let target = this.$refs.imageBox
      if (target.scrollHeight - target.clientHeight <= target.scrollTop) {
        return true
      }
    },
    //是否滚动到顶部
    isScrollTop() {
      return this.$refs.imageBox.scrollTop <= 0
    },
    changeSwiper(e) {},
    bindClickSwiper() {
      let imagesList = this.swiperData.map((item) => {
        return item.info || ''
      })
      ImagePreview({
        images: imagesList,
        startPosition: this.curSwiper
      })
    },
    onPreviewChange() {},
    updateCllect(isFirst) {
      if (!isFirst) {
        this.curSwiper = this.index
      }
      this.editIconList[2].active =
        this.swiperData[this.curSwiper].is_save === 0 ? true : false
      this.$set(this.editIconList, 2, this.editIconList[2])
    },
    //点击返回
    goback() {
      this.$router.go(-1)
    },
    dataUrlToBold(url) {
      let arr = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bStr = atob(arr[1]),
        n = bStr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bStr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    getEv() {
      wx.miniProgram.getEnv((res) => {
        this.isWx = res.miniprogram
      })
    },
    handleChange(index) {
      let miniPath = this.editIconList[index].miniPath
      if (miniPath) {
        if (this.isWx) {
          wx.miniProgram.navigateTo({ url: miniPath })
          return
        } else {
          this.$toast('非小程序内不能发布动态')
        }
      }
      if (this.editIconList[index].disabledActive) {
        return
      }
      let runFunc = this.editIconList[index].runFunc
      if (runFunc) {
        this[runFunc](index)
      }
    },
    loadBeatifulImage() {
      let active = this.editIconList[0].active
      if (active) {
        this.$toast('一键美化成功')
      } else {
        this.$toast('取消一键美化')
      }
    },
    //一键美化
    clickBeautification(index) {
      let that = this
      let active = this.editIconList[index].active
      if (!active) {
        this.editIconList[index].active = !this.editIconList[index].active
        this.$nextTick(() => {
          this.$toast.loading('美化中...')
          html2canvas(this.$refs.poster, {
            backgroundColor: null,
            useCORS: true
          })
            .then(function (canvas) {
              setTimeout(() => {
                that.$toast.clear()
                that.beautifyImageSource = canvas.toDataURL()
                that.loadBeatifulImage()
                that.$toast('图片已生成')
              }, 1500)
            })
            .catch((err) => {
              // that.clocking = false;
            })
        })
      } else {
        this.editIconList[index].active = !this.editIconList[index].active
        this.$toast('取消一键美化')
        this.beautifyImageSource = ''
      }
      /* try {
        let active = this.editIconList[index].active;
      if(!active){
        let imgMerge = new beautifyImage([
        {
          url: "https://cdnvue.gymcity.com.cn/uploads/610c31c1b6145a566cb313048a26edf1.png",
          width: 800,
          height: 550,
        },
        {
          url: "https://cdnvue.gymcity.com.cn/uploads/922fdbaed9b3a125a857cd7279c9dec8.png",
          width: 46,
          height: 32,
        },
      ]);
      imgMerge.then((img) => {
        this.beautifyImageSource = img;
      }).catch((e)=>{
        console.log(e);
      });
      }else{
        this.editIconList[index].active = !this.editIconList[index].active;
        this.$toast("取消一键美化");
        this.beautifyImageSource = "";
      }
      } catch (error) {
          alert(error);
      } */
    },
    //收藏
    collect() {
      let index = this.curSwiper
      let isSave = this.swiperData[index].is_save === 0 ? true : false
      let params = {
        tid: this.swiperData[index].id,
        type_0: this.swiperData[index].type_id,
        type: isSave ? 2 : 1
      }
      this.$http
        .getApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.swiperData[index].is_save = !isSave ? 0 : 1
            this.editIconList[2].active = !isSave
            this.$set(this.editIconList, 2, this.editIconList[2])
            if (!isSave) {
              this.showCollect = true
            } else {
              this.$toast('取消收藏')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.$toast('异常错误')
        })
    }
  }
}
</script>
<style lang="scss">
.preview-image {
  .van-dialog__header {
    font-weight: 600;
  }
  .van-swipe__indicators {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 1vw 2vw;
    border-radius: 1vw;
  }
}
</style>
<style lang="scss" scoped>
.preview-image {
  text-align: center;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  flex-direction: column;
  .top-bar {
    padding: 2vw 7.7vw;
    color: #fff;
    .top-flex {
      height: 5.6vw;
      display: flex;
      align-items: center;
      .title {
        font-size: 4vw;
        flex: 1;
        white-space: nowrap;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .iconfont {
        font-size: 5vw;
      }
    }
    .desc {
      height: 4.5vw;
      line-height: 4.5vw;
      font-size: 3.2vw;
    }
  }
  .image-content {
    position: relative;
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .image-box {
      position: relative;
      height: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: height 0.3s ease;
      .van-image {
        width: 100%;
        height: 100%;
      }
      .item-image {
        width: auto;
      }
    }
    .image-close {
      height: 50%;
    }
    .image-info {
      box-sizing: border-box;
      text-align: left;
      font-size: 3.2vw;
      color: rgba(255, 255, 255, 0.5);
      .info-content {
        padding: 9.6vw 7.5vw 2.4vw;
      }
      .desc-content {
        position: relative;
        .more {
          position: absolute;
          right: 0px;
          bottom: -16px;
          color: #3c89ff;
        }
      }
      .info-desc {
        word-break: break-all;
        white-space: pre-line;
        font-family: PingFangSC-Medium;
        font-size: 3.7vw;
        color: #fff;
        font-weight: 600;
        margin-bottom: 4.8vw;
      }
      .desc-limit {
        overflow: hidden;
        display: -webkit-box; //将元素设为盒子伸缩模型显示
        -webkit-box-orient: vertical; //伸缩方向设为垂直方向
        -webkit-line-clamp: 3; //超出3行隐藏，并显示省略号
      }
      .info-text {
        font-family: PingFangSC-Regular;
        font-size: 3.2vw;
        color: #fff;
        margin-bottom: 2.1vw;
        display: flex;
        align-items: center;
      }
      .iconfont {
        color: rgba(255, 255, 255, 0.5);
        margin-right: 2.7vw;
      }
      .info-left {
        font-family: PingFangSC-Regular;
        font-size: 3.2vw;
        color: rgba(255, 255, 255, 0.5);
        margin-right: 3.7vw;
      }
      .info-right {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
  .image-content-open {
    overflow-y: scroll;
  }
  .edit-content {
    width: 100%;
    padding: 5.3vw 0vw 8.3vw;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .edit-item {
      color: #fff;
      font-size: 3.2vw;
      .iconfont {
        height: 6vw;
        line-height: 6vw;
        color: #fff;
        font-size: 5vw;
        font-weight: 600;
      }
      .active {
        color: #f7b500;
      }
      .edit-name {
        height: 4.5vw;
        line-height: 4.5vw;
        margin-top: 1.6vw;
      }
    }
    .active {
      color: #f7b500;
    }
  }
}
.wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  .menu-container {
    width: 100%;
    padding: 0vw 5.3vw;
    margin-bottom: 5.3vw;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    .menu-list {
      background-color: #fff;
      border-radius: 2.7vw;
      .menu-item {
        height: 17vw;
        line-height: 17vw;
        border-bottom: 1px solid #f1f1f1;
        font-size: 4.3vw;
        color: #000;
      }
      .save {
        font-weight: 600;
      }
      .menu-item:last-child {
        border-bottom: none;
      }
    }
  }
}
.notice {
  font-family: PingFangSC-Regular;
  font-size: 3.7vw;
  line-height: 6.4vw;
  color: #000000;
  margin-top: 2vw;
}
.poster-content {
  position: absolute;
  width: 100%;
  height: 100%;
  .poster-box {
    width: 100%;
    padding: 4.5vw;
    box-sizing: border-box;
    background: #fff;
    text-align: left;
    position: relative;
    .poster-seal {
      width: 28.3vw;
      height: 28.3vw;
      position: absolute;
      right: 0vw;
      bottom: 0vw;
    }
  }
  .poster-image {
    border-radius: 2.1vw;
    overflow: hidden;
  }
  .poster-text {
    font-family: HYRunYuan-FEW;
    font-size: 4vw;
    letter-spacing: 0.5vw;
    color: #3b4761;
    margin: 4.3vw 0vw 4vw;
    font-weight: 600;
  }
  .poster-info {
    font-family: PingFangSC-Light;
    font-size: 2.9vw;
    letter-spacing: 0.3vw;
    color: #3b4761;
    margin-top: 5.6vw;
    margin-bottom: 3vw;
  }
  .class-name {
    margin-right: 4.5vw;
  }
  .beautiful-image-box {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 22;
  }
}
.indicator-content {
  color: #fff;
  padding: 2vw 3vw;
  font-size: 3vw;
  border-radius: 2vw;
  background: rgba(0, 0, 0, 0.5);
}
.my-swipe {
  width: 100%;
  height: 100%;
  max-height: 100%;
}
</style>
